import { v4 as uuidv4 } from "uuid";
export class CommandCenterConfiguration {
	pk: string; //:commandCenter
	sk: string; //configuration
	menu: CommandCenterMenuConfiguration[];

	public constructor(init?: Partial<CommandCenterConfiguration>) {
		Object.assign(this, init);
	}
}

export class CommandCenterMenuConfiguration {
	key: string = uuidv4();
	label: string;
	faIcon: string;
	faIconPrefix: string;
	routerLink: string[];
	itemUserLevel: number;
	itemUserPermission: string;
	parentKey: string;
	sortOrder: number;
	description?: string;

	public constructor(init?: Partial<CommandCenterMenuConfiguration>) {
		Object.assign(this, init);
	}
}
